export default __webpack_public_path__ + "static/media/Large Napalm Cocktail.de7e4ae4.PNG";